module.exports = __webpack_public_path__ + "img/img16.2ad34694.png";